import { render, staticRenderFns } from "./UserEditPage.vue?vue&type=template&id=c2b8110e&scoped=true"
import script from "./UserEditPage.vue?vue&type=script&lang=js"
export * from "./UserEditPage.vue?vue&type=script&lang=js"
import style0 from "./UserEditPage.vue?vue&type=style&index=0&id=c2b8110e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b8110e",
  null
  
)

export default component.exports